<template>
  <div v-if="profile && profile.name">
    <p
      class="p-button-text profile"
      type="span"
      :label="profile.name"
      @click="toggle"
    >
      <span class="iconContainer">
        <i :class="['pi', 'pi-user']"></i> </span
      >{{ profile.name }}
    </p>
    <OverlayPanel ref="op" class="my-account pt-2">
      <ul class="profile-menu not-first">
        <li>
          <a
            @click="switchProfile()"
            :class="['p-link', 'myAccountDesplegable']"
          >
            <span class="iconContainer mr-2">
              <i :class="['pi', 'pi-user']"></i>
            </span>
            <span>{{ $t("menu.profile") }}</span>
          </a>
        </li>
        <li @click="logout()" :class="['p-link', 'myAccountDesplegable']">
          <a>
            <span class="iconContainer mr-2">
              <i :class="['pi', 'pi-power-off']"></i>
            </span>
            <span>{{ $t("menu.closeSession") }}</span>
          </a>
        </li>
      </ul>
    </OverlayPanel>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RoutesMixin from "@/utils/routes";
export default {
  mixins: [RoutesMixin],
  data() {
    return {};
  },
  methods: {
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    onClick(event) {
      this.expanded = !this.expanded;
      event.preventDefault();
    },
    logout() {
      this.$keycloak.logout();
    },
    switchProfile() {
      this.to({ name: "profile" });
    },
  },
  computed: {
    ...mapState(["profile"]),
  },
};
</script>

<style lang="scss" scoped>
.role {
  color: darkgray;
}

.profile {
  color: #000 !important;
  text-align: center;
  cursor: pointer;
}

.profile:hover {
  color: #70adda !important;
  background: transparent !important;
  border-color: transparent !important;
}
.p-overlaypanel {
  top: 90px !important;
  transform: translate(57%, 0%);

  ul {
    list-style: none;
    padding-left: 0px;
    margin: 0px;
    li {
      margin-bottom: 10px;
    }
  }
}
</style>